/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Range_FromInputs */

const en_shopping_range_from = /** @type {(inputs: Shopping_Range_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From`)
};

const de_shopping_range_from = /** @type {(inputs: Shopping_Range_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von`)
};

/**
* | output |
* | --- |
* | "From" |
*
* @param {Shopping_Range_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_range_from = /** @type {((inputs?: Shopping_Range_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Range_FromInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_range_from(inputs)
	return en_shopping_range_from(inputs)
});